import * as React from "react";
import { defineCustomElements as deckDeckGoHighlightElement } from "@deckdeckgo/highlight-code/dist/loader";

import "./BlogPost.css";
import Layout from "../components/Layout";
import { BlogPostTag } from "../components/BlogPostTag";

// calling this function is important, it enables the code syntax highlighting
deckDeckGoHighlightElement();

type BlobPostTemplateProps = {
    frontmatter: {
        title: string;
        date: string;
        tags: string[];
    };
    html: string;
};

export function BlogPostTemplate({ frontmatter, html }: BlobPostTemplateProps) {
    return (
      <Layout>
        <section className="mb-8">
          <h1 className="text-black font-sans text-4xl font-normal leading-none mb-4 tracking-tighter">{frontmatter.title}</h1>
          <h2 className="text-gray-600 font-sans text-sm font-normal leading-snug mb-2">{frontmatter.date}</h2>
          <div className="flex space-x-2">
            {
              frontmatter.tags.map((tag: string) => <BlogPostTag key={tag} tag={tag} />)
            }
          </div>
        </section>
  
  
        <div className="markdown prose max-w-none" dangerouslySetInnerHTML={{ __html: html }} />
      </Layout>
    );
  }
